// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__CLSSi","container":"styles_container__3Pc9E","title":"styles_title__1OeeL","wrapper":"styles_wrapper__1yX35","answer":"styles_answer__2_AEJ"};